<template>
    <div class="page">
        <div class="inner">
            <div class="main-title" v-if="false">
                <div class="left">
                    <span>提交订单</span>
                </div>
            </div>

            <div class="section">
                <div class="section-title">选择收货人地址</div>
                <div class="section-ctx">
                    <div class="address-list">
                        <div class="sectionHintText" v-if="list_address && list_address.length == 0">还没有收件地址</div>
                        <div
                            class="address-item"
                            v-for="(item, index) in list_address"
                            :key="index"
                            :class="{ active: item.id == address_selected.id }"
                            @click="do_toggle_address(item)"
                        >
                            <div class="address-top">{{ item.name_phone }}</div>
                            <div class="address-bottom">
                                {{ item.full_addr }}
                            </div>
                            <img src="@/static/order/addr-select.png" alt="" class="marker" />
                        </div>
                    </div>
                    <div class="btn-box">
                        <button class="btn-ripple" @click="open_addr_add()">+新增地址</button>
                    </div>
                </div>
            </div>

            <div class="section section-pay">
                <div class="section-title">支付信息</div>
                <div class="section-ctx section-ctx-type">
                    <div class="pay-group">
                        <div class="title">支付方式：</div>
                        <div class="pay-items">
                            <div
                                class="item"
                                v-for="(item, index) in payTypeOption"
                                @click="do_toggle_paytype(item)"
                                :class="{ checked: pay_type_value == item.value }"
                                :key="index"
                            >
                                <img class="img-check check-0 check-img check-img-0" src="@/static/common/newCheck.png" alt="" />
                                <img class="img-check check-1 check-img check-img-1" src="@/static/common/newCheck2.png" alt="" />
                                <img class="marker-img" :src="item.icon" alt="" />
                                <span>{{ item.title }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="yue-info" v-if="payType == '余额支付'">
                        <div class="info-item">
                            <div class="info-label">可用余额：</div>
                            <div class="info-val">{{ total_balance }}</div>
                        </div>
                        <div class="info-item" v-if="total_balance < this.real_payment_money">
                            <div class="info-label yue-warn-tip">提示：您的余额不足，请选择其他支付方式</div>
                        </div>
                    </div>

                    <!-- 线下转款信息 -->
                    <div class="xianxia-info" v-if="payType == '线下转款'">
                        <div class="info-item">
                            <div class="info-label">收款单位名称:</div>
                            <div class="info-val">{{ webConfig.offline_company }}</div>
                        </div>
                        <div class="info-item">
                            <div class="info-label">收款单位账号:</div>
                            <div class="info-val">{{ webConfig.offline_code }}</div>
                        </div>
                        <div class="info-item">
                            <div class="info-label">开户银行:</div>
                            <div class="info-val">{{ webConfig.offline_bank }}</div>
                        </div>
                        <div class="info-item scroll-target-pingzheng">
                            <div class="info-label">转账凭证:</div>
                            <div class="info-val">
                                <el-upload
                                    class="upload-demo"
                                    list-type="picture-card"
                                    multiple
                                    accept="image/*"
                                    :limit="upload_limit_number"
                                    :name="upload_col_name"
                                    :action="uploadAction"
                                    :data="uploadExtraData"
                                    :on-success="uploadSuccess_pingjia"
                                    :before-upload="beforeUpload_pingjia"
                                    :on-preview="handlePictureCardPreview"
                                >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 发票信息 -->
            <div class="section invoiceBox">
                <div class="section-title">发票信息</div>
                <div class="fill40"></div>
                <div class="invoiceLineBox">
                    <div class="title">是否开票:</div>
                    <div class="flexBox">
                        <div @click="invoiceSwitch(0)" class="inItem btn-ripple" :class="{ active: invoicType == 0 }">不开票</div>
                        <div @click="invoiceSwitch(1)" class="inItem btn-ripple" :class="{ active: invoicType == 1 }">普通发票</div>
                        <div @click="invoiceSwitch(2)" class="inItem btn-ripple" :class="{ active: invoicType == 2 }">专用发票</div>
                    </div>
                </div>
                <!-- 普通发票 -->
                <el-form
                    ref="invoiceForm"
                    v-show="invoicType == 1"
                    :rules="invoiceFormRules"
                    class="invoiceForm"
                    label-position="right"
                    :model="invoiceForm"
                    label-width="120px"
                >
                    <el-form-item label="发票抬头类型:" prop="radio">
                        <el-radio-group v-model="invoiceForm.radio">
                            <el-radio label="0">个人</el-radio>
                            <el-radio label="1">企业</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="发票抬头:" prop="input">
                        <el-input v-model="invoiceForm.input" placeholder="请填写准确的抬头名称"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号:" prop="input3" v-show="invoiceForm.radio == 1">
                        <el-input v-model="invoiceForm.input3" placeholder="请填写纳税人识别号"></el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱:" prop="input2">
                        <el-input v-model="invoiceForm.input2" placeholder="请填写电子邮箱，用于接收电子发票"></el-input>
                    </el-form-item>
                </el-form>

                <!-- 专用发票 -->
                <el-form
                    ref="invoiceForm2"
                    class="invoiceForm2"
                    label-position="right"
                    :rules="invoiceFormRules"
                    :model="invoiceForm2"
                    label-width="120px"
                    v-show="invoicType == 2"
                >
                    <el-form-item label="发票抬头:" prop="input">
                        <el-input v-model="invoiceForm2.input" placeholder="请填写准确的抬头名称"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号:" prop="input2">
                        <el-input v-model="invoiceForm2.input2" placeholder="请填写准确的纳税人识别号"></el-input>
                    </el-form-item>
                    <el-form-item label="注册地址:" prop="input3">
                        <el-input v-model="invoiceForm2.input3" placeholder="请输入单位注册地址"></el-input>
                    </el-form-item>
                    <el-form-item label="注册电话:" prop="input4">
                        <el-input v-model="invoiceForm2.input4" placeholder="请输入单位注册电话"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行:" prop="input5">
                        <el-input v-model="invoiceForm2.input5" placeholder="请输入开户银行"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账户:" prop="input6">
                        <el-input v-model="invoiceForm2.input6" placeholder="请输入银行账户"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱:" prop="input7">
                        <el-input v-model="invoiceForm2.input7" placeholder="请输入邮箱"></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 收货人地址 -->
            <div class="type-select" v-if="false">
                <div class="type-title">
                    <div class="text">配送方式</div>
                </div>
                <div class="type-inner">
                    <div class="select-1">
                        <div class="title">配送方式</div>
                        <div class="list">
                            <button
                                class="item"
                                :class="peisong_type == item ? 'active' : ''"
                                v-for="(item, index) in opts_peisong"
                                :key="index"
                                @click="peisong_toggle(item)"
                            >
                                {{ item }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 收货人地址 -->
            <!-- 商品列表 -->

            <div class="section section-product">
                <div class="section-title">订单商品</div>
                <div class="section-ctx" style="padding-top: 20px">
                    <div class="goods-list">
                        <div class="list">
                            <div class="goods-list-inner">
                                <!-- 标题 -->
                                <div class="list-title flex">
                                    <div class="box-title">
                                        <div class="title-text">信息</div>
                                    </div>
                                    <div class="box-num">数量</div>
                                    <div class="box-subtitle">小计</div>
                                </div>

                                <!-- 商品列表 -->
                                <div class="heightScrollBox">
                                    <div class="item" v-for="(item, index) in configList" :key="index">
                                        <div class="item-detail flex">
                                            <div class="box-title flex">
                                                <div class="title-box">
                                                    {{ item.name }}
                                                </div>
                                            </div>
                                            <div class="box-num">{{ item.num }}</div>
                                            <div class="box-subtitle">
                                                <div v-if="item.price">{{ vuex_huobi }} {{ item.price }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="order-action">
                            <div class="order-action-inner">
                                <div class="section-item" v-if="list_coupon.length">
                                    <div class="sub-title" @click="showCoupon = !showCoupon" :class="{ 'expand-0': !showCoupon }">
                                        <div class="text">使用优惠</div>
                                        <img src="@/static/common/pay-arrow-top.png" alt="" />
                                    </div>

                                    <div class="yhq-list" v-if="showCoupon">
                                        <div
                                            class="yhq-item"
                                            v-for="(item, index) in list_coupon"
                                            :key="index"
                                            :class="{ active: coupon_select_id == item.id }"
                                            @click="handleCouponSelect(item)"
                                        >
                                            <img src="@/static/address/dizhi-check-1.png" alt="" class="marker" />

                                            <div class="yhq-top">
                                                <div class="yhq-1">
                                                    <div class="text-1">{{ vuex_huobi }}{{ +item.jian }}</div>
                                                    <div class="text-2">满{{ +item.man }}</div>
                                                </div>
                                                <div class="yhq-2">有效期至 {{ item.endTime && item.endTime.substr(0, 10) }}</div>
                                            </div>
                                            <div class="yhq-bottom">
                                                <div class="yhq-3">[{{ item.title }}]</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="yhq-select-info">
                                        <b>金额抵用</b>

                                        <template v-if="coupon_select.id">
                                            <b class="number">{{ vuex_huobi }}{{ +coupon_select.jian }}</b
                                            >, 使用【{{ coupon_select.title }}】优惠券 1张，优惠 {{ +coupon_select.jian }} 元
                                        </template>
                                        <template v-else> 无 </template>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="countTotal">
                            <span class="text">价格：</span>
                            <b>{{ vuex_huobi }} {{ configObj.price }}</b>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 操作按钮 -->
            <div class="bottom-btns">
                <!-- <button class="btn-ripple fit-text btn-1" @click="$router.push('/cart')">返回购物车</button> -->
                <button class="btn-ripple fit-text btn-2" @click="do_submit()">提交订单</button>
            </div>
        </div>

        <!-- 新增收货地址弹窗 -->
        <address_modal ref="address_modal" @confirm="confirm_add_address" />
        <foreign_address_modal ref="foreign_address_modal" @confirm="confirm_add_address" />

        <!-- 余额支付弹窗 -->
        <balance_password_set_modal ref="balance_password_set_modal" />
        <!-- 余额支付弹窗 -->
        <balance_pay_modal ref="balance_pay_modal" />
        <!-- 余额支付失败弹窗 -->
        <balance_pay_disable_modal ref="balance_pay_disable_modal" />
        <!-- 微信支付弹窗 -->
        <orderPayWxCode ref="orderPayWxCode" :payment_money="pay_info.orderPrice" />
        <!-- 支付等待弹窗 -->
        <orderPayWaiting ref="orderPayWaiting" />

        <!-- 图片预览 -->
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>

        <!-- 订单支付提示 -->
        <el-dialog
            class="modal-pay-tip"
            title="提示"
            :visible.sync="order_confirm_tip"
            width="30%"
            :close-on-click-modal="false"
            :append-to-body="true"
        >
            <span>是否申请改价？</span>
            <span slot="footer" class="dialog-footer">
                <button class="btn-ripple btn-cancel" @click="changeCancel">取 消</button>
                <button class="btn-ripple btn-confirm" @click="changeConfirm">确 定</button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { SHOP_TYPE } from '@/config/env.js'

import address_modal from '@/components/address/address_modal.vue' //新增地址
import foreign_address_modal from '@/components/address/foreign_address_modal.vue' //新增地址

import balance_password_set_modal from '@/components/payment/balance_password_set_modal.vue'
import balance_pay_modal from '@/components/payment/balance_pay_modal.vue'
import balance_pay_disable_modal from '@/components/payment/balance_pay_disable_modal.vue'

import orderPayWxCode from '@/components/order/orderPayWxCode2.vue'
import orderPayWaiting from '@/components/order/orderPayWaiting.vue'

import { mapState } from 'vuex'

export default {
    name: 'order-submit2',
    components: {
        address_modal,
        foreign_address_modal,

        balance_password_set_modal,
        balance_pay_modal,
        balance_pay_disable_modal,
        orderPayWxCode,
        orderPayWaiting,
    },
    data() {
        return {
            is_order_test: false, //订单测试
            //
            from: '', //product-detail  ||  cart
            //
            address_selected: {}, //地址
            pagination_address: {
                page: 1,
                pagenum: 20,
            },
            coupon_selected: {}, //优惠券
            coupons_for_allow_use: [],
            //
            total_product_number: 0, // 商品总数量
            total_product_price: 0, //商品总金额
            total_order_price: 0, //订单总金额
            order_zhekou_bili: 10, //折扣比例 10折 默认不打折
            order_zhekou_price: 0, //折扣金额
            order_yunfei: 0, //运费金额
            order_points_dixian_price: 0, //积分抵现金额
            order_points_dixian_number: 0, //使用积分数量

            pay_info: {}, //预下单信息
            jifen_pay: {
                // if_open: 1,//是否开启积分抵现
                // jifen: "17",//可用积分
                // money: "1.70",//可抵扣金额
                // rule: 10//抵扣比例 rule 积分抵扣 1元
            }, //积分抵现信息
            //

            my_info: {}, //我的信息 包含 余额 佣金数值
            total_balance: 0,

            invoice_info: {
                // invoicStatus: 0, //是否开票 0-不需要 1-需要发票
                // invoicType: '1', //发票类型：1-普通发票 2-专用发票
                invoicType: 1, // 是否开票：0.不开票，1.普通发票，2.专用发票
                titleType: '1', //抬头：1-个人 2-单位
                title: '', //
                shibiema: '', //
                companyAddress: '', //
                companyPhone: '', //
                bankName: '', //
                bankNo: '', //
            },

            // 发票
            invoicType: 0, // 是否开票：0.不开票，1.普通发票，2.专用发票
            invoiceForm: {
                radio: '0', // 发票抬头类型：0.个人，1.企业
                input: '', // 发票抬头
                input3: '', // 纳税人识别号
                input2: '', // 电子邮箱
            }, // 普通发票
            invoiceForm2: {
                input: '', // 发票抬头
                input2: '', // 纳税人识别号
                input3: '', // 注册地址
                input4: '', // 注册电话
                input5: '', // 开户银行
                input6: '', // 银行账户
                input7: '', // 邮箱
            }, // 专用发票
            invoiceFormRules: {}, // 发票表单验证规则

            // 支付方式
            pay_type_value: 'zhifubao',
            payTypeOption: [
                { value: 'zhifubao', title: '支付宝支付', icon: require('@/static/payment-options/type-zfb.png') },
                { value: 'weixin', title: '微信支付', icon: require('@/static/payment-options/type-weixin.png') },
                // { value: 'xianxia', title: '线下转款', icon: require('@/static/payment-options/type-xianxia.png') },
                // { value: 'paypal', title: 'PayPal', icon: require('@/static/payment-options/type-paypal.png') },
                // { value: 'yue', title: '余额支付', icon: require('@/static/payment-options/type-yue.png') },
            ],

            order_id: '', //是否已经创建过订单
            showCoupon: true, //

            if_use_jifen: true, //是否使用积分抵扣
            if_use_yongjin: true, //是否使用佣金扣减
            jifen_pay: {}, //积分抵扣信息
            currency: '￥', //货币

            money_yunfei: 0,
            order_price: 0, //总 订单金额

            yh_code: '',
            yh_code_info: {},

            peisong_type: '快递配送',
            address_selected: {},
            address: '', //选择的地址
            list_address: [], //地址列表
            payment_products: [], //要支付的商品信息
            list_coupon: [], //优惠券
            coupon_select_id: '', //选择的优惠券 id

            // select_date: "", //日期
            // select_time: "", //时间

            shouhuo_name: '', //自提 取货人姓名
            shouhuo_phone: '', //自提 取货人电话

            // pickerOptions: {
            //   disabledDate(time) {
            //     return time.getTime() < Date.now() - 1000 * 60 * 60 * 24 * 1 || time.getTime() > Date.now() + 1000 * 60 * 60 * 24 * 6;
            //   },
            // },

            form: {
                real_name: '',
                phone: '',
                address: '',
                company: '',
                u_group: '',
                worker: '',
            },

            is_pay_pass: 0, //是否设置余额支付密码
            payType: '',
            upload_limit_number: 6,
            dialogVisible: false,
            dialogImageUrl: '', //转账图片查看
            order_confirm_tip: false, //确认支付信息提示
            xianxia_file_list: [],

            configList: [], // 配置清单
            configObj: {},
        }
    },
    computed: {
        ...mapState(['if_calc_yunfei']),

        real_payment_money() {
            let money = this.total_order_price.toFixed(2)
            return money
        },
        //

        coupon_select() {
            return this.list_coupon.find((v) => v.id == this.coupon_select_id) || {}
        },

        opts_peisong() {
            let arr = ['快递配送', '上门自提']
            return arr
        },

        //使用积分支付要抵扣的积分
        use_jifen_num() {
            if (!this.if_use_jifen) {
                return 0
            }

            //需要优先考虑选择优惠券后的积分数值变动
            let jifen = 0
            let total_dixian_jifen = this.jifen_pay.jifen || 0 //最大可抵扣积分数值
            if (this.money_yhq) {
                if (this.jifen_pay.money && this.order_price) {
                    //最大可抵扣金额 = （剩余待支付金额 = 订单金额 - 优惠金额） 与  可使用积分的最大抵扣金额

                    let last_dixian_jifen = (this.order_price - this.money_yhq) * this.jifen_pay.rule
                    if (last_dixian_jifen < 0) {
                        total_dixian_jifen = 0
                    } else {
                        total_dixian_jifen = last_dixian_jifen < total_dixian_jifen ? last_dixian_jifen : total_dixian_jifen
                    }
                }
            }
            if (this.baseInfo.jifen && total_dixian_jifen) {
                if (this.baseInfo.jifen < total_dixian_jifen) {
                    jifen = this.baseInfo.jifen
                } else {
                    jifen = total_dixian_jifen
                }
            }

            return parseInt(jifen)
        },

        //优惠金额
        money_yhq() {
            let money_yhq = 0
            if (this.coupon_select_id) {
                let yhq = this.list_coupon.find((v) => v.id == this.coupon_select_id) || {}
                money_yhq = yhq.jian || 0
            }
            return money_yhq
        },

        //积分抵现金额
        money_jifen_dixian() {
            let money = 0
            if (this.use_jifen_num && this.jifen_pay.rule) {
                money = this.use_jifen_num / this.jifen_pay.rule
            }
            return +money
        },

        //佣金抵现金额
        money_yongjin_dixian() {
            if (!this.if_use_yongjin) {
                return 0
            }
            if (!this.baseInfo.yongjin) {
                return 0
            }
            // debugger
            let money_yongjin = 0
            let money_last = 0 //剩余待支付金额
            if (this.order_price) {
                money_last = this.order_price - this.money_yhq - this.money_jifen_dixian

                if (money_last > this.baseInfo.yongjin) {
                    money_yongjin = this.baseInfo.yongjin
                } else {
                    money_yongjin = money_last
                }
            }

            return money_yongjin.toFixed(2)
        },
    },
    watch: {
        'invoiceForm.radio': {
            immediate: true,
            handler(newV) {
                this.setInvoiceFormRules()
            },
        },
        'invoiceForm.radio2': {
            immediate: true,
            handler(newV) {
                this.setInvoiceFormRules()
            },
        },
        'invoiceForm2.radio': {
            immediate: true,
            handler(newV) {
                this.setInvoiceFormRules()
            },
        },
        'invoiceForm2.radio2': {
            immediate: true,
            handler(newV) {
                this.setInvoiceFormRules()
            },
        },
        invoicType: {
            immediate: true,
            handler(newV) {
                this.setInvoiceFormRules()
            },
        },
    },
    created() {
        this.from = this.$route.query.from || ''
        this.query_user()
        this.query_address()
        this.getConfigList()
    },
    mounted(){ 
        this.$nextTick(() => {
            window.scrollTo(0,0);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0; 
        });
    },
    methods: {
        async changeConfirm() {
            let obj = {
                id: this.order_id,
            }
            this.$load.open()
            let res = await this.applyPriceAjax(obj)
            await this.$load.close()
            if (res && res.code == 200) {
                alertSucc('申请成功')
                this.$router.push('/order-list2')
            }
        },
        changeCancel() {
            // 去支付
            this.do_order_pay()
        },
        applyPriceAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drumorder_applyPrice',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        async getConfigList() {
            let madeObj = JSON.parse(sessionStorage.getItem('madeObj'))
            let obj = madeObj.obj
            if (!obj) {
                alertErr('没有定制鼓列表')
                return
            }
            obj['is_zhekou'] = 1
            let res = await this.drumPayinfo(obj)
            if (res && res.code == 200) {
                let data = res.data
                if (!data.list) {
                    alertErr('请选择配置项')
                    this.$router.go(-1)
                    return
                }
                this.configObj = data
                let configList = []
                data.list.forEach((item, index) => {
                    if (item.child) {
                        let list = item.child
                        list.forEach((item2, index2) => {
                            configList.push(item2)
                        })
                    }
                })
                this.configList = configList
            } else {
                alertErr(res.msg)
            }
        },
        // 发票表单验证规则
        setInvoiceFormRules() {
            function checkPhoneFun(val) {
                if (!val) {
                    return false
                }
                let regu = /^1[3-9][0-9]{9}$/

                if (regu.test(val)) {
                    return true
                } else {
                    return false
                }
            }
            function checkEmailFun(val) {
                if (!val) {
                    return false
                }
                let regu = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

                if (regu.test(val)) {
                    return true
                } else {
                    return false
                }
            }
            let checkEmail = (rule, value, callback) => {
                if (value == '') {
                    callback(new Error('请输入邮箱'))
                } else if (!checkEmailFun(value)) {
                    callback(new Error('请输入正确的邮箱'))
                } else {
                    callback()
                }
            }
            let checkPhone = (rule, value, callback) => {
                if (value == '') {
                    callback(new Error('请输入手机号'))
                } else if (!checkPhoneFun(value)) {
                    callback(new Error('请输入正确的手机号'))
                } else {
                    callback()
                }
            }

            // 普通票-个人-邮箱
            let rules = {
                input: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
                input2: [{ required: true, validator: checkEmail, trigger: 'blur' }],
            }
            // 普通票-企业-邮箱
            let rules3 = {
                input: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
                input2: [{ required: true, validator: checkEmail, trigger: 'blur' }],
                input3: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
            }
            // 专用票-邮箱
            let rules5 = {
                input: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
                input2: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
                input3: [{ required: true, message: '请输入注册地址', trigger: 'blur' }],
                input4: [{ required: true, validator: checkPhone, trigger: 'blur' }],
                input5: [{ required: true, message: '请输入开户银行', trigger: 'blur' }],
                input6: [{ required: true, message: '请输入银行账户', trigger: 'blur' }],
                input7: [{ required: true, validator: checkEmail, trigger: 'blur' }],
            }

            let invoicType = this.invoicType
            let invoiceForm = this.invoiceForm
            let invoiceForm2 = this.invoiceForm2

            this.invoiceFormRules = {}

            this.$nextTick(() => {
                if (invoicType == 1 && invoiceForm.radio == 0) {
                    // 普通票-个人-邮箱
                    this.invoiceFormRules = rules
                    this.$nextTick(() => {
                        if (this.$refs.invoiceForm) {
                            this.$refs.invoiceForm.clearValidate()
                        }
                        if (this.$refs.invoiceForm2) {
                            this.$refs.invoiceForm2.clearValidate()
                        }
                    })
                } else if (invoicType == 1 && invoiceForm.radio == 1) {
                    // 普通票-企业-邮箱
                    this.invoiceFormRules = rules3
                    this.$nextTick(() => {
                        if (this.$refs.invoiceForm) {
                            this.$refs.invoiceForm.clearValidate()
                        }
                        if (this.$refs.invoiceForm2) {
                            this.$refs.invoiceForm2.clearValidate()
                        }
                    })
                } else if (invoicType == 2) {
                    // 专用票-邮箱
                    this.invoiceFormRules = rules5
                    this.$nextTick(() => {
                        if (this.$refs.invoiceForm) {
                            this.$refs.invoiceForm.clearValidate()
                        }
                        if (this.$refs.invoiceForm2) {
                            this.$refs.invoiceForm2.clearValidate()
                        }
                    })
                }
            })
        },
        // 发票切换
        invoiceSwitch(val) {
            this.invoicType = val
        },

        //下单成功后 移除商品信息
        clearCacheProduct() {
            if (this.from == 'cart') {
                //移除购物车中商品
                let guige_ids = this.payment_products.map((v) => v.guige_id).join(',')
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'gouwuche_del',
                        inventoryId: guige_ids, //产品规格id(多个用,分开)
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        this.$store.commit('set_vuex_cart_number', res.count)
                    }
                })
            }
            sessionStorage.removeItem('cache_payment_products')
        },

        //获取缓存的地址信息
        query_user() {
            // this.$store.dispatch("query_user");
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'users_userInfo',
                },
            }).then((res) => {
                if (res.code == 200) {
                    this.my_info = res.data
                    this.total_balance = parseFloat(this.my_info.money) || 0
                }
            })
        },

        //获取地址列表
        query_address() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'userAddress_lists',
                    ...this.pagination_address,
                    // shop_id: this.id,
                },
            }).then((res) => {
                if (res.code == 200) {
                    let data = res.data

                    data.forEach((v) => {
                        if (SHOP_TYPE == 'foreign') {
                            //海伦鼓尚
                            v.full_addr = [v.country, v.province, v.city, v.area, v.address].filter((v) => !!v).join(',')
                            v.name_phone = `${v.firstName} ${v.lastName} (${v.phone})`
                        } else {
                            v.full_addr = [v.country, v.province, v.city, v.area, v.address].filter((v) => !!v).join(',')
                            v.name_phone = `${v.name} (${v.phone})`
                        }
                    })
                    this.list_address = data

                    let obj = data.find((v) => v.if_default) || {}
                    this.address_selected = obj || {}
                }
            })
        },

        get_pay_info_params() {
            let product_items = this.payment_products.map((v) => ({
                inventoryId: v.inventoryId,
                productId: v.productId,
                num: v.num,
            }))
            let productInfo = JSON.stringify(product_items)

            let params = {
                productInfo: productInfo,
                addressId: this.address_selected.id || '',
            }
            return params
        },

        get_pay_params() {
            let product_items = this.payment_products.map((v) => ({
                inventoryId: v.inventoryId,
                productId: v.productId,
                num: v.num,
            }))
            let productInfo = JSON.stringify(product_items)

            let invoiceObj = {}

            if (this.invoicType == 1) {
                // 普通票
                invoiceObj.invoiceStatus = 1 // 需要发票
                invoiceObj.invoiceType = 1 // 发票类型：1.普通票，2.专用票
                invoiceObj.titleType = this.invoiceForm.radio == 0 ? 1 : 2 // 抬头类型：1.个人，2.企业
                invoiceObj.title = this.invoiceForm.input // 发票抬头
                invoiceObj.email = this.invoiceForm.input2
                if (this.invoiceForm.radio == 1) {
                    // 企业
                    invoiceObj.shibiema = this.invoiceForm.input3 // 纳税人识别号
                }
            } else if (this.invoicType == 2) {
                // 专用票
                invoiceObj.invoiceStatus = 1 // 需要发票
                invoiceObj.invoiceType = 2 // 发票类型：1.普通票，2.专用票
                invoiceObj.title = this.invoiceForm2.input // 抬头
                invoiceObj.shibiema = this.invoiceForm2.input2 // 纳税人识别号
                invoiceObj.companyAddress = this.invoiceForm2.input3 // 注册地址
                invoiceObj.companyPhone = this.invoiceForm2.input4 // 注册电话
                invoiceObj.bankName = this.invoiceForm2.input5 // 开户银行
                invoiceObj.bankNo = this.invoiceForm2.input6 // 银行账户
                invoiceObj.email = this.invoiceForm2.input7
            } else {
                invoiceObj.invoiceStatus = 0
            }

            let madeObj = JSON.parse(sessionStorage.getItem('madeObj'))

            let params = {
                addressId: this.address_selected.id || '',
                ...invoiceObj,
                ...madeObj.obj,
            }

            let madeTypeObj = madeObj.madeTypeObj
            if (madeTypeObj['madeType'][1]) {
                params['upload_file1'] = madeTypeObj['uploadFileList'][0]
            } else {
                params['upload_file1'] = ''
            }

            if (madeTypeObj['madeType'][2]) {
                params['upload_file2'] = madeTypeObj['uploadFileList'][1]
            } else {
                params['upload_file2'] = ''
            }

            if (madeTypeObj['madeType'][3]) {
                params['upload_file3'] = 1
            } else {
                params['upload_file3'] = ''
            }

            if (madeObj.remark) {
                params['remark'] = madeObj.remark
            }
            return params
        },

        drumPayinfo(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'drumorder_drumPayinfo',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },

        //根据下单商品获取确认订单信息
        query_pay_info() {
            let params = this.get_pay_info_params()

            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'orders_getPayInfo',
                    ...params,
                },
            }).then((res) => {
                let { code, data, msg } = res
                if (code == 200) {
                    this.pay_info = data
                    this.jifen_pay = data.jifen_pay || {} //积分信息

                    this.total_order_price = data.order_price || 0
                    //this.total_product_price = data.goods_price || 0;
                    this.order_zhekou_bili = parseFloat(data.zhekou) || 10
                    this.order_zhekou_price = parseFloat(data.zhekou_price) || 0
                    this.order_yunfei = data.yunfei || 0

                    // this.format_coupon_view_info(data.yhq_list)
                    // this.coupons_for_allow_use = data.yhq_list || []
                    // this.total_product_price = data.goods_price;

                    if (this.coupon_selected.id) {
                        this.total_order_price = (this.total_order_price - this.coupon_selected.jian).toFixed(2)
                    }

                    // if (data.yhq_list.length) {
                    //   this.list_coupon = data.yhq_list.map((item) => ({
                    //     ...item,

                    //     miaoshu: +item.man
                    //       ? `满${+item.man}减${+item.jian}元`
                    //       : `下单立减${+item.jian}元`,
                    //     youxiaoqi:
                    //       item.startTime.substr(0, 10) + " - " + item.endTime.substr(0, 10),
                    //   }));
                    // }
                    // this.order_price = data.order_price;
                    // this.money_yunfei = +data.yunfei || 0;
                    // this.jifen_pay = data.jifen_pay;
                }
            })
        },

        // 格式化优惠券展示信息
        format_coupon_view_info(list) {
            list.forEach((v) => {
                // v.is_expand = false;
                v.man_price = parseFloat(v.man)
                v.jian_price = parseFloat(v.jian)
                v.tiaojian = v.man_price == 0 ? '无门槛' : `满${v.man_price}元可用`
            })
        },

        do_toggle_paytype(item) {
            this.pay_type_value = item.value
            this.payType = item.title
            let value = item.title
            if (value == '余额支付') {
                if (this.baseInfo.is_pay_pass == 0) {
                    //未设置支付密码
                    this.$refs.balance_password_set_modal.init(this.baseInfo)
                } else if (this.total_balance < this.real_payment_money) {
                    //余额不足提示
                    this.$refs.balance_pay_disable_modal.init({
                        money: this.real_payment_money,
                    })
                }
            }
        },

        yuePayPassSetCallback() {
            this.is_pay_pass = 1
        },

        parentHandleModalAction(option = {}) {
            let type = option.type || ''
            if (type == '修改绑定') {
                this.$store.dispatch('query_user')
            }
        },

        //提交订单
        async do_submit() {
            let params_info = {
                ...this.form,
            }
            delete params_info.phone

            if (!this.address_selected.id) {
                alertErr('请选择收货地址')
                return
            }

            if (!this.pay_type_value) {
                alertErr('请选择支付方式')
                return
            }

            if (this.pay_type_value == 'balance') {
                if (this.total_balance < +this.real_payment_money) {
                    alertErr('您的余额不足，请选择其他支付方式')
                    return
                }
            }
            if (this.invoicType == 1) {
                // 普通票表单验证
                this.$refs['invoiceForm'].validate((valid) => {
                    if (!valid) {
                        alertErr('请填写正确的发票信息')
                        return false
                    }
                    this.do_confirm_submit()
                })
            } else if (this.invoicType == 2) {
                // 专用票表单验证
                this.$refs['invoiceForm2'].validate((valid) => {
                    if (!valid) {
                        alertErr('请填写正确的发票信息')
                        return false
                    }
                    this.do_confirm_submit()
                })
            } else {
                // 不需要发票
                this.do_confirm_submit()
            }
        },

        //滚动到指定位置 元素类名
        scrollToTarget(clsName) {
            // var element = document.querySelector(".wenxian-box");
            var element = document.querySelector(clsName)
            element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
        },

        //订单提交-支付
        do_confirm_submit() {
            this.$load.open()
            let params = this.get_pay_params()
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'drumorder_create',
                    ...params,
                },
            }).then(async (res) => {
                await this.$load.close()
                if (res.code == 200) {
                    let { id, orderNo, msg } = res.data
                    this.order_id = id
                    this.order_confirm_tip = true
                } else {
                    alertErr(res.msg)
                }
            })
        },

        //支付方式调取
        do_order_pay() {
            if (this.is_order_test) {
                this.pay_use_yue()
            } else {
                if (this.pay_type_value == 'weixin') {
                    this.order_payment_wx_pc()
                } else if (this.pay_type_value == 'zhifubao') {
                    this.order_payment_zfb()
                } else if (this.pay_type_value == 'yue') {
                    this.pay_use_yue()
                } else if (this.pay_type_value == 'xianxia') {
                    this.order_payment_xianxia()
                } else if (this.pay_type_value == 'paypal') {
                    this.pay_use_paypal()
                }
            }
        },

        pay_use_yue() {
            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'pay_balance',
                    orderType: 3,
                    orderId: this.order_id,
                },
            }).then((res) => {
                alert(res)
                let { code, message } = res
                if (code == 200) {
                    this.toPaySuccess()
                } else {
                }
            })
        },

        pay_use_paypal() {
            this.toPaySuccess()

            // this.$api({
            //   url: '/service.php',
            //   method: 'get',
            //   data: {
            //     action: 'pay_balance',
            //     orderType: 1,
            //     orderId: this.order_id,
            //   },
            // }).then((res) => {
            //   alert(res)
            //   let { code, message } = res;
            //   if (code == 200) {
            //     this.toPaySuccess();
            //   } else {
            //   }
            // });
        },

        //微信支付 pc
        order_payment_wx_pc() {
            this.$load.open()
            this.$api('pay_wxScanCodePay', {
                orderId: this.order_id,
                orderType: 3,
            }).then((res) => {
                this.$load.close()
                let { code, data } = res
                if (res.code == 200) {
                    let info = {
                        qrcode: res.data.data.qrcode,
                        order_id: this.order_id,
                    }
                    this.$refs.orderPayWxCode.init(info)
                } else {
                    this.$alert(res.message)
                }
            })
        },

        //pc 支付宝支付
        order_payment_zfb() {
            this.$load.open()
            this.$api('pay_aliScanCodePay', {
                orderId: this.order_id,
                orderType: 3,
            }).then((res) => {
                this.$load.close()
                let { code, msg, data } = res
                if (code == 1) {
                    this.$router.push({
                        path: '/zfbPay',
                        query: {
                            htmlData: data,
                        },
                    })
                    // const { href } = this.$router.push({
                    //     path: '/zfbPay',
                    //     query: {
                    //         htmlData: data,
                    //     },
                    // })
                    // window.open(href, '_blank')

                    // this.$router.push({
                    //   path: "/zfbPay",
                    //   query: {
                    //     htmlData: data,
                    //   },
                    // });
                }
            })
        },

        //余额支付
        order_payment_yue() {
            if (+this.baseInfo.money < +this.real_payment_money) {
                alertErr('您的余额不足，请选择其他支付方式')
                return
            }

            this.$api('orders_yuePay', { order_id: this.order_id }).then((res) => {
                //console.log("余额支付", res);
                let { code, message } = res

                if (code == 200) {
                    this.toPaySuccess()
                } else {
                }
            })
        },

        //线下转款
        order_payment_xianxia() {
            // this.$api("orders_offlinePay", { order_id: this.order_id }).then((res) => {
            //   //console.log("货到付款支付", res);
            //   let { code, message } = res;

            //   if (code == 200) {
            //     this.toPaySuccess();
            //   } else {
            //     this.toFail();
            //   }
            // });

            let paypz = this.xianxia_file_list.join()
            this.$api('orders_uploadPz', {
                //
                order_id: this.order_id,
                paypz: paypz,
            }).then((res) => {
                //console.log("线下转款支付", res);
                let { code, message } = res
                if (code == 200) {
                    this.toPaySuccess()
                } else {
                    this.toFail()
                }
            })
        },

        toFail() {
            this.$router.push(`/payFail?order_id=${this.order_id}`)
        },

        //订单微信jsapi支付
        orderPayWxJsapi() {
            let that = this
            order.orders_wxPay({
                params: {
                    order_id: this.order_id,
                },
                success: (data) => {
                    //console.log("订单微信jsapi支付", data);
                    let { timeStamp, nonceStr, signType, paySign } = data

                    wx.chooseWXPay({
                        timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr, // 支付签名随机串，不长于 32 位
                        package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign, // 支付签名
                        success: function (res) {
                            that.toPaySuccess()
                        },
                        fail(err) {
                            //console.log("支付失败了");
                        },
                    })
                },
                fail: (err) => {
                    //console.log("支付失败", err);
                },
            })
        },

        showWaiting() {
            this.clearTimer()
            let that = this

            this.$refs.orderPayWaiting.show = true

            this.timer = setInterval(() => {
                this.$api('orders_detail', {
                    id: this.order_id,
                }).then((res) => {
                    let { code, data, msg } = res
                    if (data.status == 2 || data.status == 3) {
                        that.toPaySuccess()
                    }
                })
            }, 2000)
        },

        clearTimer() {
            //console.log("清除定时器");
            clearInterval(this.timer)
            this.timer = null
        },
        //支付成功操作
        toPaySuccess() {
            if (this.mode == 'yue') {
                this.$router.push(`/yue`)
            } else {
                this.$router.push(`/payment-success?order_id=${this.order_id}`)
            }
        },

        order_pay_step() {
            //支付步骤
            //优惠券

            //积分 1
            //佣金 2
            //其他 3
            if (this.if_use_jifen && this.use_jifen_num > 0) {
                this.order_jifen_dixian() //积分抵现
            } else if (this.if_use_yongjin && this.money_yongjin_dixian) {
                this.order_yongjin_pay() //佣金支付
            }
        },

        //购物车 删除支付的商品
        shopcart_delete_payment() {
            let ids = this.payment_products.map((v) => v.inventoryId)
            let id = ids.join()

            this.$api({
                url: '/service.php',
                method: 'get',
                data: {
                    action: 'gouwuche_del',
                    inventoryId: inventoryId,
                },
            }).then((res) => {
                if (res.code == 200) {
                    let list = this.list_shopcart
                    let ids = (inventoryId + '').split(',')
                    //可能删除多项商品
                    ids.forEach((inventoryId) => {
                        let index = list.findIndex((v) => v.inventoryId == inventoryId)
                        list.splice(index, 1)
                    })

                    this.do_update_vuex_cart_number()
                }
            })
        },

        //选择收货地址
        do_toggle_address(item) {
            this.address_selected = item
            this.query_pay_info()
        },
        //新增地址
        open_addr_add() {
            if (SHOP_TYPE == 'foreign') {
                this.$refs.foreign_address_modal.init()
            } else {
                this.$refs.address_modal.init()
            }
        },

        confirm_add_address() {
            this.query_address()
        },

        // 订单积分抵现
        order_jifen_dixian() {
            this.$api('orders_jifenPay', {
                order_id: this.order_id,
                jifen: this.use_jifen_num,
            }).then((res) => {
                //console.log("积分抵现", res);
                let { code, is_over, message } = res
                if (code == 200) {
                    if (this.if_use_yongjin && this.money_yongjin_dixian) {
                        this.order_yongjin_pay()
                    } else {
                        alert(res)
                        if (is_over == 1) {
                            //支付完成
                            this.$router.push('/order-list')
                        } else {
                            this.to_pay_methods()
                        }
                    }
                }
            })
        },

        //订单佣金抵现
        order_yongjin_pay() {
            this.$api('orders_yuePay', {
                order_id: this.order_id,
            }).then((res) => {
                //console.log("余额抵扣", res);
                let { code, is_over } = res
                if (code == 200) {
                    alert(res)
                    if (is_over == 1) {
                        //支付完成
                        this.$router.push('/order-list')
                    } else {
                        this.to_pay_methods()
                    }
                }
            })
        },

        //订单创建成功
        to_pay_methods() {
            if (this.$route.query.from == 'cart') {
                this.shopcart_delete_payment()
            }

            this.$router.push({
                path: '/payment-methods',
                query: {
                    order_id: this.order_id,
                    from: 'order-submit',
                },
            })
        },

        //输入积分时
        onInput_jifen() {
            //console.log("输入积分", +this.use_jifen_num);
            //console.log("最多可使用积分", +this.jifen_pay.jifen);

            if (this.use_jifen_num && +this.use_jifen_num > +this.jifen_pay.jifen) {
                alertErr(`输入的积分大于${this.jifen_pay.jifen},请重新输入`)
                this.use_jifen_num = ''
            }
        },

        peisong_toggle(item) {
            //console.log("配送方式", item);

            this.peisong_type = item

            if (item == '上门自提') {
                //console.log("用户地址", { ...this.address_selected });
                if (this.address_selected.id) {
                    this.shouhuo_name = this.address_selected.name
                    this.shouhuo_phone = this.address_selected.phone
                }
            }
        },

        //上传相关
        uploadSuccess_pingjia(res, file) {
            //console.log("上传结果", res);
            let { code, data, msg } = res
            alert(res)
            if (code == 200) {
                this.xianxia_file_list.push(res.data)
            }
        },

        beforeUpload_pingjia(file) {
            const isLt2M = file.size / 1024 / 1024 < 20 //文件大小
            return isLt2M
        },

        handlePictureCardPreview(file) {
            // this.dialogImageUrl = file.url;
            this.dialogImageUrl = file.response.data
            this.dialogVisible = true
        },

        //优惠券相关
        handleCouponSelect(item) {
            //console.log("优惠券", { ...item });
            this.coupon_select_id = item.id
        },

        toPaySuccess() {
            this.toPayResult(1)
        },
        toPayFail() {
            // this.toPayResult(0)
            this.toRoute({
                path: '/order-detail',
                query: {
                    from: 'payment',
                    id: this.order_id,
                },
                mode: 'reLaunch',
            })
        },

        toPayResult(is_pay = 0) {
            // this.clearCacheProduct()
            this.toRoute({
                path: '/payment-success2',
                query: {
                    id: this.order_id,
                    type: 'order',
                    is_pay: is_pay,
                },
            })
        },
    },
}
</script>

<style scoped lang="less">
/deep/ .el-form-item {
    &:last-child {
        margin-bottom: 0;
    }
}

/deep/ .el-form-item__label {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 40px;
}

/deep/ .el-radio__inner {
    width: 22px;
    height: 22px;
}

/deep/ .el-radio__inner::after {
    width: 8px;
    height: 8px;
}

/deep/ .el-radio__label {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 14px;
}

.upload-box {
    padding: 20px 20px;
    text-align: left;
}

.btn-cancel {
    min-width: 100px;
    height: 40px;
    border: 1px solid #ff4d00;
    color: #ff4d00;
    font-size: 14px;
}

.btn-confirm {
    margin-left: 20px;
    min-width: 100px;
    height: 40px;
    background: #ff4d00;
    color: #fff;
    font-size: 14px;
}

.img-check {
    cursor: pointer;

    &.check-0 {
        display: block;
    }

    &.check-1 {
        display: none;
    }
}

.checked {
    cursor: pointer;

    .check-0 {
        display: none !important;
    }

    .check-1 {
        display: block !important;
    }
}

.page {
    background: #ffffff;
    text-align: center;
    font-size: 14px;

    .inner {
        width: @width;
        // width: 100%;
        margin: 0 auto;
        padding: 30px 0 30px 0;
        background: #fff;
    }

    .main-title {
        .flex-between();
        margin-bottom: 30px;
        text-align: left;

        .left {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333;

            .num {
                margin-left: 10px;
            }
        }

        .right {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 24px;
            color: #333333;

            .el-select {
                width: 250px;
            }

            .step-box {
                width: 500px;
                margin: 0 auto;
                font-size: 14px;
                .flex();

                .step {
                    flex: 1;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    background: #eee;
                    cursor: pointer;
                    transition: 0.3s;

                    &:hover {
                        opacity: 0.75;
                    }

                    &.step-1 {
                        clip-path: polygon(0% 0%, 97% 0%, 100% 50%, 97% 100%, 0% 100%);
                    }

                    &.step-2 {
                        clip-path: polygon(0% 0%, 97% 0%, 100% 50%, 97% 100%, 0% 100%, 3% 50%);
                    }

                    &.step-3 {
                        clip-path: polygon(0% 0%, 97% 0%, 100% 50%, 97% 100%, 0% 100%, 3% 50%);
                    }

                    &.active {
                        background: #ff4d00;
                        color: #fff;
                    }
                }
            }
        }
    }

    .goods-list {
        // border: 1px solid #cccccc;
        // margin-bottom: 40px;
        text-align: left;

        .title {
            padding-left: 20px;
            height: 48px;
            line-height: 48px;
            background: #f5f5f5;
            border-bottom: 1px solid #cccccc;
            font-size: 14px;
            font-weight: bold;
            color: #333333;
        }

        .list {
            .list-title {
                font-size: 14px;
                text-align: center;
                height: 50px;
                background: #f7f7f7;
                padding: 15px 18px 15px 0;

                font-family: OPPOSans, OPPOSans;
                // font-weight: bold;
                font-size: 14px;
                color: #666666;

                // border-bottom: 1px solid #ddd;
                .box-title {
                    flex: 1;
                    text-align: left;

                    .title-text {
                        margin-left: 70px;
                    }
                }

                .box-sku {
                    width: 240px;
                }

                .box-unit {
                    width: 240px;
                }

                .box-num {
                    width: 240px;
                }

                .box-subtitle {
                    width: 240px;
                }
            }

            .heightScrollBox {
                box-sizing: border-box;
                width: 100%;
                overflow-x: hidden;
                overflow-y: auto;
                max-height: 300px;
            }

            .item {
                border-bottom: 1px solid #eee;

                &:last-child {
                    border-bottom: none;
                }

                .box-number {
                    width: 240px;
                    .flex-center();

                    input {
                        width: 48px;
                        height: 30px;
                        border: 1px solid #d5d8de;
                        text-align: center;
                        border-left: 0;
                        border-right: 0;

                        &::-webkit-outer-spin-button,
                        &::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                        }
                    }

                    button {
                        width: 30px;
                        height: 30px;
                        border: 1px solid #d5d8de;
                    }
                }

                .item-detail {
                    padding: 15px 0 15px 40px;
                    text-align: center;
                    font-family: OPPOSans, OPPOSans;
                    // font-weight: bold;
                    font-size: 14px;
                    color: #666666;
                    box-sizing: border-box;

                    .box-title {
                        flex: 1;

                        .title-box {
                            color: #333333;
                        }

                        .poster-box {
                            width: 92px;
                            height: 64px;
                            margin-left: 90px;
                            margin-right: 16px;
                            background: #ffffff;
                            border-radius: 0px 0px 0px 0px;
                            border: 1px solid #9f9f9f;
                            display: flex;
                            align-items: center;

                            .elImg {
                                width: 60px;
                                height: 60px;
                                margin: 0 auto;
                            }
                        }
                    }

                    .box-sku {
                        width: 240px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 14px;
                    }

                    .box-unit {
                        width: 240px;
                        color: #ff4d00;
                    }

                    .box-num {
                        width: 240px;
                    }

                    .box-subtitle {
                        width: 240px;
                        color: #ff4d00;
                    }
                }
            }
        }

        .huizong {
            padding: 20px 53px;
            // background: #f9f9f9;

            .item {
                margin-bottom: 16px;
                text-align: right;
                font-weight: 400;
                font-size: 18px;
                line-height: 18px;
                color: #666666;

                &:last-child {
                    margin-bottom: 0;
                }

                b {
                    display: inline-block;
                    min-width: 185px;
                    font-weight: 400;
                    font-size: 18px;
                    color: #666666;
                    line-height: 18px;
                }
            }

            .total {
                text-align: right;

                b {
                    font-family: Arial, Arial;
                    font-weight: bold;
                    font-size: 20px;
                    color: #ff4d00;
                }
            }
        }

        .countTotal {
            padding: 24px 53px;
            background: #efefef;
            text-align: right;
            font-weight: 400;
            font-size: 20px;
            line-height: 20px;
            color: #666666;
            margin-top: 20px;

            b {
                display: inline-block;
                min-width: 185px;
                font-weight: 400;
                font-size: 26px;
                color: #ff4d00;
                line-height: 26px;
                font-weight: bold;
            }
        }
    }

    .hintText {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 30px;

        .hintIcon {
            width: 24px;
            height: 24px;
            margin-right: 12px;
        }

        .hintTextStr {
            font-size: 14px;
            line-height: 14px;
            color: #555555;
        }
    }

    .bottom-btns {
        display: flex;
        justify-content: flex-end;

        button {
            & + button {
                margin-left: 16px;
            }

            &.btn-1 {
                width: 200px;
                height: 50px;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #000000;
                font-weight: 400;
                font-size: 16px;
                color: #000000;
                line-height: 16px;
            }

            &.btn-2 {
                width: 200px;
                height: 50px;
                background: #ff4d00;
                border-radius: 0px 0px 0px 0px;
                font-weight: 400;
                font-size: 16px;
                color: #ffffff;
                line-height: 16px;
            }

            &:hover {
                opacity: 0.8;
            }
        }
    }
}

.ziti-wrap {
    margin-bottom: 40px;
    text-align: left;
    min-height: 127px;
    background: #ffffff;
    border: 1px solid #cccccc;

    .ziti-title {
        .flex-between();
        padding-left: 20px;
        padding-right: 20px;
        height: 48px;
        line-height: 48px;
        background: #f9f9f9;
        border-bottom: 1px solid #cccccc;
        border-top: none;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
    }

    .ziti-ctx {
        padding: 30px 20px;

        .ziti-info {
            margin-bottom: 15px;
            .flex();

            span {
                display: inline-block;
                min-width: 100px;
            }

            .el-input {
                width: auto;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
}

// 支付配送方式选择

.type-select {
    margin-bottom: 40px;
    text-align: left;
    min-height: 127px;
    background: #ffffff;
    border: 1px solid #cccccc;

    .type-title {
        padding-left: 20px;
        padding-right: 20px;
        height: 48px;
        line-height: 48px;
        background: #f9f9f9;
        border-bottom: 1px solid #cccccc;
        border-top: none;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
    }

    .type-inner {
        padding: 30px 20px;

        .select-1 {
            .flex();

            & + .select-1 {
                margin-top: 30px;
            }

            .title {
                font-size: 14px;
                font-weight: bold;
                color: #333333;
            }

            .list {
                padding-left: 20px;

                button {
                    margin-right: 20px;
                    min-width: 96px;
                    height: 30px;
                    line-height: 30px;
                    background: #ffffff;
                    border: 1px solid #cccccc;

                    &.active {
                        border: 1px solid #ff4d00;
                    }
                }
            }
        }

        .ziti-box {
            padding-top: 10px;

            .title {
                font-weight: bold;
            }

            .ziti-info {
                margin-top: 10px;
            }
        }
    }
}

.invoiceBox {
    width: 100%;

    .fill40 {
        width: 100%;
        height: 20px;
    }

    .invoiceLineBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 20px;

        .flexBox {
            display: flex;
            align-items: center;
            justify-content: center;

            .inItem {
                width: 105px;
                height: 33px;
                background: #ffffff;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #d6d6d6;
                font-weight: 400;
                font-size: 16px;
                color: #333333;
                line-height: 33px;
                text-align: center;
                margin-right: 20px;
                cursor: pointer;

                &.active {
                    border: 1px solid #ffa58d;
                }

                &:hover {
                    border: 1px solid #ffa58d;
                }
            }
        }

        .title {
            min-width: 100px;
            font-weight: 400;
            font-size: 16px;
            color: #666666;
            line-height: 16px;
        }
    }

    .invoiceForm {
        width: 600px;
    }

    .invoiceForm2 {
        width: 600px;
    }
}

// 订单优惠等
.order-action {
    background: #f9f9f9;
    background: #fff;
    padding: 0 0;

    .order-action-inner {
        // border-bottom: 1px solid #ddd;
        padding-bottom: 20px;
    }

    .section-item {
        margin-bottom: 20px;
    }

    .section-title {
        margin-bottom: 20px;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
    }

    .section-tip {
        margin-bottom: 5px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 25px;
        color: #666666;
    }

    .section-input {
        margin-top: 5px;
        margin-bottom: 5px;

        input {
            display: inline-block;
            width: 240px;
            height: 35px;
            background: #ffffff;
            border: 1px solid #cccccc;
            opacity: 1;
            border-radius: 4px;
            padding-left: 15px;
        }

        textarea {
            border: 1px solid #cccccc;
            outline: none;
            width: 460px;
            min-height: 100px;
            background: #fff;
            resize: none;
            padding: 10px 15px;
            border-radius: 4px;
        }

        .el-input {
            width: 340px;
        }

        .el-select {
            width: 340px;
        }

        .el-textarea {
            width: 460px;
            width: 100%;
        }
    }

    .use-jifen-num {
        margin-top: 10px;
        margin-bottom: 10px;

        b {
            color: #ff4d00;
        }
    }

    .section-btn-actions {
        .flex();

        .btn {
            width: 160px;
            height: 32px;
            margin-right: 20px;
            font-size: 16px;
            font-weight: bold;
            background: #e1e1e1;
            color: #333333;

            &.active {
                background: #009a44;
                color: #ffffff;
            }
        }
    }
}

// 新增
.section {
    padding-bottom: 30px;
    text-align: left;

    .section-title {
        padding-bottom: 20px;
        border-bottom: 1px solid #d5d8de;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
    }

    .section-ctx {
        .sectionHintText {
            width: 100%;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            line-height: 16px;
        }

        .address-list {
            margin-top: 20px;
            display: flex;
            flex-wrap: wrap;

            .address-item {
                position: relative;
                margin-top: 20px;
                margin-right: 40px;
                width: 440px;
                width: 470px;
                min-height: 130px;
                padding: 15px 20px;
                background: #ffffff;
                border-radius: 4px 4px 4px 4px;
                border: 2px solid #d5d8de;
                overflow: hidden;
                cursor: pointer;

                &:nth-child(3n) {
                    margin-right: 0;
                }

                &:nth-child(-n + 3) {
                    margin-top: 0;
                }

                &.active {
                    border: 2px solid #ff4d00;

                    .marker {
                        display: block;
                    }
                }

                .marker {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    right: -1px;
                    bottom: -1px;
                    display: none;
                }

                .address-top {
                    padding-bottom: 15px;
                    border-bottom: 1px solid #d5d8de;
                    font-size: 14px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #000000;
                }

                .address-bottom {
                    padding-top: 15px;
                    font-size: 14px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                }
            }
        }

        .btn-box {
            margin-top: 20px;

            button {
                min-width: 124px;
                min-height: 32px;
                background: #ffffff;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #b9b9b9;
                font-size: 14px;
                font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
                font-weight: normal;
                color: #666666;
            }
        }
    }
}

.section-info {
    .input-list {
        display: flex;
        flex-wrap: wrap;

        .input-item {
            width: 440px;
            margin-top: 34px;
            margin-right: 40px;

            &:nth-child(3n) {
                margin-right: 0;
            }

            &:nth-child(-n + 3) {
                margin-top: 0;
            }

            .label {
                margin-bottom: 16px;
                font-size: 14px;
                font-weight: normal;
                color: #666666;

                span {
                    color: #ff4d00;
                }
            }

            .val {
                .img-address-edit {
                    margin-left: 15px;
                    width: 16px;
                    cursor: pointer;
                }
            }
        }
    }
}

// 支付配送
.section-pay {
    .pay-group {
        margin-top: 20px;
        .flex();

        .title {
            min-width: 100px;
            font-weight: 400;
            font-size: 16px;
            color: #666666;
            line-height: 16px;
        }

        .pay-items {
            flex: 1;
            .flex();

            .item {
                .flex();
                margin-right: 60px;
                cursor: pointer;

                .check-img {
                    width: 22px;
                    height: 22px;
                }

                .check-img-1 {
                    display: none;
                }

                .marker-img {
                    width: 39px;
                    margin: 0 10px;
                }

                span {
                    font-size: 16px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #000000;
                }
            }
        }

        .peisong-items {
            .item {
                text-align: center;
                width: 144px;
                height: 40px;
                line-height: 40px;
                background: #ffffff;
                border-radius: 3px 3px 3px 3px;
                border: 1px solid #ff4d00;
                font-size: 14px;
                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                font-weight: bold;
                color: #ff4d00;
            }
        }
    }
}

.section-product {
    .sub-title {
        padding-left: 30px;
        height: 50px;
        background: #fafbfc;
        cursor: pointer;

        &.expand-0 {
            margin-bottom: 15px;
        }

        .text {
            font-size: 14px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
        }

        img {
            width: 16px;
            margin-left: 15px;
        }
    }

    .yhq-list {
        display: flex;
        flex-wrap: wrap;
        padding: 15px;

        .yhq-item {
            position: relative;
            margin-right: 24px;
            width: 220px;
            height: auto;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #e5e5e5;
            cursor: pointer;

            &.active {
                border-color: #ff4d00;

                .marker {
                    display: block;
                }
            }

            .marker {
                position: absolute;
                right: 0;
                bottom: 0;
                display: none;
            }

            .yhq-top {
                height: auto;
                background: #fdf2ef;
                padding: 10px 15px;

                .yhq-1 {
                    .flex();
                    align-items: flex-end;

                    .text-1 {
                        font-size: 24px;
                        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                        font-weight: bold;
                        color: #ff4d00;
                    }

                    .text-2 {
                        margin-left: 5px;
                        font-size: 12px;
                        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                        font-weight: 400;
                        color: #333333;
                    }
                }

                .yhq-2 {
                    margin-top: 10px;
                    font-size: 12px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                }
            }

            .yhq-bottom {
                height: 32px;
                line-height: 32px;
                padding: 0 15px;
                font-size: 12px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #ff4d00;
            }
        }
    }

    .yhq-select-info {
        height: 50px;
        line-height: 50px;
        background: #fafbfc;
        padding: 0 30px;

        .number {
            color: #ff4d00;
            margin: 0 10px;
        }
    }
}

.section-ctx-type {
    padding-left: 32px;
    padding-left: 0;
}

// 余额信息
.yue-info {
    margin-top: 20px;
    padding: 24px 120px;
    padding: 24px 32px;
    // padding-bottom: 0;
    border: 1px dashed #ccc;

    .info-item {
        .flex();
        align-items: flex-start;
        // margin-bottom: 10px;

        .info-label {
            line-height: 32px;
            padding-right: 10px;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #666666;
        }

        .info-val {
            line-height: 32px;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #666666;
        }

        .yue-warn-tip {
            color: #ff4d00;
            font-size: 14px;
        }
    }
}

// 线下转款信息
.xianxia-info {
    margin-top: 32px;
    padding: 24px 120px;
    padding: 24px 32px;
    // padding-bottom: 0;
    border: 1px dashed #ccc;

    .info-item {
        .flex();
        align-items: flex-start;
        margin-bottom: 10px;

        .info-label {
            line-height: 32px;
            padding-right: 10px;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #666666;
        }

        .info-val {
            line-height: 32px;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #666666;
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/shop/order-submit.less"></style>

<style lang="less">
@media screen and (max-width: 1199px) {
    .modal-pay-tip {
        .el-dialog {
            width: 80% !important;

            .el-dialog__header {
                height: 40px;
                line-height: 40px;
                padding-left: 15px;
            }

            .el-dialog__title {
                font-size: 16px;
            }

            .el-dialog__headerbtn {
                top: 10px;
                right: 10px;
            }

            .el-dialog__headerbtn .el-dialog__close {
                font-size: 24px;
            }

            .el-dialog__body {
                padding: 30px 20px;
                font-size: 14px;
            }

            .el-dialog__footer {
                padding-bottom: 25px;
                display: flex;
                justify-content: center;
            }

            .btn-cancel {
                height: 32px;
            }

            .btn-confirm {
                height: 32px;
            }
        }
    }
    .page .goods-list .countTotal{
        padding: 10px!important;
    }
    .page .bottom-btns button.btn-2{
        width: fit-content!important;
        height: auto !important;
        line-height: 1!important;
        padding: 5px 10px;
        font-size: 18px!important;
    }
    .page .goods-list .list .item .item-detail .box-title{
        flex: 1!important;
        text-align: left;
    }
    .page .goods-list .list .item .item-detail .box-num{
        flex: .5!important;
        font-size: 14px;
    }
    .page .goods-list .list .item .item-detail .box-subtitle{
        font-size: 12px;
        div{
            font-size: 12px;
            text-align: left;
            padding-left: 2rem;
        }
    }
    .page .goods-list .list .goods-list-inner{
        width: 100%!important;
    }
}
</style>
